import React from 'react';
import { Select, SelectProps } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { useInsuranceCompaniesSupportedByProviderAndPatientQuery } from '@uplift/queries';


export type InsuranceSelectInputProps = Pick<SelectProps, 'name' | 'label' | 'className' | 'disabled'> & {
  providerId: string;
  helperText?: React.ReactNode;
};


export const InsuranceSelectInput: React.FC<InsuranceSelectInputProps> = ({ providerId, ...props }) => {
  const l10n = useL10n();
  const { data: availableInsuranceCompanies, isFetching } = useInsuranceCompaniesSupportedByProviderAndPatientQuery(providerId);

  return (
    <Select
      {...props}
      items={availableInsuranceCompanies?.map(c => ({ value: c.id, label: c.name })) ?? []}
      disabled={props.disabled || isFetching}
      placeholder={(availableInsuranceCompanies?.length || isFetching) ? undefined : l10n.matching.insurance.noAvailableInsurances}
      helperText={props.helperText}
    />
  );
};
